export default __webpack_public_path__ + "static/media/Compute_EP_Studio.8853df38.svg";